<template>
  <v-container id="how" class="how" bg="l">
    <v-headline :level="2" class="how-headline uppercase"
      >{{ dic.howItWorks.title }} {{ dic.brand }}</v-headline
    >

    <v-carousel
      class="how-carousel"
      :slides="explonations"
      v-slot:default="cProps"
    >
      <v-media class="how-media" :halfFilling="$mq.resize && $mq.above(1200)">
        <template v-slot:left>
          <div class="padding">
            <carousel-list
              class="how-list"
              :slides="cProps.slides"
              :currId="cProps.currId"
              :transitionName="cProps.transitionName"
              @before-enter="cProps.beforeEnter"
              @after-leave="cProps.afterLeave"
              @swipe="cProps.handleNav"
            >
              <template v-slot:default="{ slide }">
                <div class="slide">
                  <p class="slide-label text-b">{{ slide.label }}</p>
                  <p class="slide-description text-sm">
                    {{ slide.description }}
                  </p>
                </div>
              </template>
            </carousel-list>

            <div class="how-carousel-navigation">
              <carousel-nav-button
                class="how-carousel-button how-carousel-button-l"
                direction="prev"
                :isRounded="false"
                containerTheme="dark"
                pointerTheme="light"
                @navclick="cProps.handleNav"
              />

              <carousel-nav-button
                class="how-carousel-button how-carousel-button-r"
                direction="next"
                :isRounded="false"
                containerTheme="dark"
                pointerTheme="light"
                @navclick="cProps.handleNav"
              />
            </div>
          </div>
        </template>
        <!-- END MEDIA LEFT -->

        <template v-slot:right>
          <div class="imac">
            <picture class="imac-bg">
              <source
                :srcset="require(`@/assets/img/screen2.webp`)"
                type="image/webp"
              />
              <img
                class="imac-bg"
                alt="Sovtes screenshot report"
                :src="require(`@/assets/img/screen2.png`)"
              />
            </picture>
            <carousel-list
              class="imac-list"
              :slides="cProps.slides"
              :currId="cProps.currId"
              :transitionName="cProps.transitionName"
            >
              <template v-slot:default="{ slide }">
                <picture>
                  <source
                    :srcset="
                      require(`@/assets/img/explanation_slides/${slide.imgUrl}`)
                    "
                    type="image/webp"
                  />
                  <img
                    :src="
                      require(`@/assets/img/explanation_slides/${slide.imgClassicUrl}`)
                    "
                    alt="#"
                    class="imac-photo"
                  />
                </picture>
              </template>
            </carousel-list>
          </div>
        </template>
      </v-media>
    </v-carousel>
  </v-container>
</template>

<script>
import VHeadline from '@/components/ui/VHeadline'
import VContainer from '@/components/ui/VContainer'
import VMedia from '@/components/ui/VMedia'
import VCarousel from '@/components/carousel/VCarousel'
import CarouselList from '@/components/carousel/CarouselList'
import CarouselNavButton from '@/components/carousel/CarouselNavButton'

import { mapState } from 'vuex'

export default {
  name: 'SectionHowItWorks',
  data() {
    return {
      id: 1,
    }
  },
  components: {
    VHeadline,
    VContainer,
    VMedia,
    VCarousel,
    CarouselList,
    CarouselNavButton,
  },
  computed: {
    ...mapState('how', ['explonations']),
   currentLang() {
      //this need for wake up store listner 
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner 
      return this.$store.state.main.dic
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.imac {
  position: relative;

  &-bg {
    width: 100%;
    position: absolute;
    top: 0;
    transform: scale(1.1) translateY(0px);
    z-index: 9999;
  }

  &-photo {
    width: 100%;
    min-height: 290px;
  }

  &-list {
    position: relative;
    width: 510px;
    height: 400px;
    align-self: flex-end;
  }
}
</style>

<style scoped lang="scss">
.slide {
  max-width: 600px;
  min-height: 220px;

  & > p {
    line-height: 1.5;
    padding: 10px 0;
  }

  &-label {
    font-weight: 600;
  }

  &-description {
  }
}
</style>

<style scoped lang="scss">
.how-headline {
  display: block;
  text-align: center;
  padding: 30px 0;
  color: #021759;
}

.how {
  background-image: url('../../assets/img/backgrounds/artboard3.webp'),
    url('../../assets/img/backgrounds/artboard3.jpg');
  background-size: cover;
  min-height: 600px;

  &-headline {
    display: block;
    text-align: center;
    padding: 30px 0;
    color: #021759;
  }

  &-media {
    margin: 30px 0 0 0;
  }

  &-carousel {
    text-align: left;

    &-button {
      margin: 0;
    }

    &-button-l {
      margin-right: 20px;
    }
    &-button-r {
      margin-left: 20px;
    }

    &-navigation {
      margin: 15px 0;
    }
  }

  &-content {
    text-align: left;
    &:first-child {
      font-size: 20px;
    }
  }
}

.img {
  width: 500px;
  height: 330px;
  top: 63px;
  right: -30px;
  position: absolute;
  transform: scale(1);
}

.padding {
  padding: 20px 0;
  box-sizing: border-box;
}
</style>

<style lang="scss" scoped>
@media (max-width: 1125px) {
  .how-media {
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .how-headline {
    padding: 10px 0;
  }

  .how-media {
    margin: 0;
  }

  .padding {
    padding: 0 0 20px 0;
  }

  .slide {
    max-width: 800px;
    min-height: 0px;
  }

  .imac {
    &-list {
      width: 460px;
      height: 350px;
    }
  }
}

@media (max-width: 600px) {
  .how-media {
    justify-content: center;
  }

  .imac {
    &-list {
      width: 360px;
      height: 250px;
      align-self: center;
    }
  }
}

@media (max-width: 425px) {
  .how {
    min-height: 0;
  }
  .imac {
    &-list {
      width: 310px;
      height: 230px;
      align-self: center;
    }

    &-photo {
      min-height: 182px;
    }
  }
}

@media (max-width: 375px) {
}
</style>
